import React from 'react';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

import ThreeppRadioButton from '../RadioButton/RadioButton';

class ThreeppRadioGroup extends React.Component {
  handleChange = event => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(event.target.value);
    }
  };

  /**
   * row
   * selected: []
   * options: [{
   *   color
   *   value
   *   label
   * }]
   */
  render() {
    const { options, selected, disabled, title, row, error } = this.props;
    const radioButtons = options.map(option => {
      const isSelected = option.value === selected;
      return (
        <ThreeppRadioButton
          disabled={disabled}
          key={option.value}
          value={option.value}
          label={option.label}
          selected={isSelected}
          onChange={this.handleChange}
        />
      );
    });
    return (
      <>
        <FormControl>
          {title && <FormLabel>{title}</FormLabel>}
          <RadioGroup row={row}>{radioButtons}</RadioGroup>
        </FormControl>
        {error && <FormHelperText error>{error}</FormHelperText>}
      </>
    );
  }
}

export default ThreeppRadioGroup;
